import { getToken, removeToken } from "./cookieUtil";
import { clearAuthData, getAuthData } from "./localStorage";
import { isPlatform } from "@ionic/react";
import { getCordovaAuthData, getCordovaToken, removeCordovaAuthData, removeCordovaToken } from "./secureTokenService";

export const isUserAuthenticated = async (): Promise<boolean> => {
  const hasToken = getToken();
  const hasAuthData = getAuthData();
  const cordovaAuthData = await getCordovaAuthData();
  const cordovaToken = await getCordovaToken();

  let isAuthenticated = false;
  if (isPlatform("cordova")) {
    isAuthenticated = !!cordovaToken && !!cordovaAuthData;
  } else {
    isAuthenticated = !!hasToken && !!hasAuthData;
  }

  return isAuthenticated;
};

export const logoutUser = async (): Promise<void> => {
  if (isPlatform("cordova")) {
    await removeCordovaToken();
    await removeCordovaAuthData();
  } else {
    clearAuthData();
    removeToken();
  }
};
